import { render, staticRenderFns } from "./productDetailList.vue?vue&type=template&id=1f9adc93&scoped=true"
import script from "./productDetailList.vue?vue&type=script&lang=js"
export * from "./productDetailList.vue?vue&type=script&lang=js"
import style0 from "./productDetailList.vue?vue&type=style&index=0&id=1f9adc93&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f9adc93",
  null
  
)

export default component.exports